import { EnumMemberType, EnumAnesthesiaType, EnumAnesthesiaLocation } from 'enums';

let Values = {
  SPONTANEOUS: 'SPONTANEOUS',
  ANESTHESIA: 'ANESTHESIA',
};

//-- Functions

let name = (value) => {

  switch (value) {

    case Values.SPONTANEOUS:
      return 'Locomotion spontanée'

    case Values.ANESTHESIA:
      return 'Anesthésie'

    default:
      console.error("Reached default case")
      break;
  }
};

let short = (value) => {

  switch (value) {

    case Values.ANESTHESIA:
      return 'Anesth'

    default:
      return name(value);
  }
};

let litteral = (value, anesthesiaMember, anesthesiaType, anesthesiaLocation) => {

  switch (value) {

    case Values.ANESTHESIA:
      return `${short(value)}/${EnumMemberType.short(anesthesiaMember)}/${EnumAnesthesiaType.short(anesthesiaType)}/${EnumAnesthesiaLocation.short(anesthesiaLocation)}`;

    default:
      return short(value);
  }

};

export default Object.seal({
  ...Values,

  /* All values */
  values: Object.keys(Values),

  name,
  short,
  litteral
});
